import { createFileRoute } from '@tanstack/react-router'
import { ValueStoryEdit } from 'pages/valueStories/ValueStoryEdit'
import { z } from 'zod'

export const valueStoryEditSearchSchema = z.object({})

export const Route = createFileRoute('/value-stories/$siteID/add')({
  component: ValueStoryEdit,
  staticData: {
    title: 'Add Value Story',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: valueStoryEditSearchSchema,
})
